import { takeLatest, put, call, all, fork } from 'redux-saga/effects';
import { MONTHLY_CHECKOUT_START, MONTHLY_CHECKOUT_DETAILS_START } from './MonthlyCheckout.types';
import { getMonthlyCheckout, getMonthlyCheckoutDetails } from './MonthlyCheckout.services';
import { monthlyCheckoutSuccess, monthlyCheckoutFailure, monthlyCheckoutDetailsSuccess, monthlyCheckoutDetailsFailure } from './MonthlyCheckout.actions';
import { encryptData } from '../_common/enode-decode';
import AlertManager from '../../utils/alertManager';

export function* getMonthlyCheckoutSaga(payload: any) {
    try {
		const key = "getMonthlyCheckoutKey";
				const encryptedData = encryptData(
					payload.payload,key,
				);

        // @ts-ignore
        const responseData = yield call(getMonthlyCheckout as any, encryptedData);
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else {
		if (responseData.status === 'success') {
			yield put(monthlyCheckoutSuccess(responseData.data));
		} else {
			yield put(monthlyCheckoutFailure(responseData.data));
		}
	}
    } catch (error: any) {
        const backendMessage = error?.response?.data?.message_text || error?.response?.data?.message;
        const status = error?.response?.status;
        const message = backendMessage || (status ? `Request failed with status ${status}` : 'Network Error');
        yield put(monthlyCheckoutFailure(message));
    }
}

export function* getMonthlyCheckoutDetailsSaga(payload: any) {
	try {
		const key = "getMonthlyCheckoutDetailsKey";
		const encryptedData = encryptData(
				payload.payload,key,
		);
		// @ts-ignore
		const responseData = yield call(getMonthlyCheckoutDetails as any, encryptedData);
		console.log('MonthlyCheckout Details API Response:', responseData);
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else {
		if (responseData.status === 'success') {
			yield put(monthlyCheckoutDetailsSuccess(responseData.data));
		} else {
			yield put(monthlyCheckoutDetailsFailure(responseData.data));
		}
	}
	} catch (error: any) {
		console.error('MonthlyCheckout Details API Error:', error);
		yield put(monthlyCheckoutDetailsFailure(error?.response?.data?.message || 'An error occurred'));
	}
}

export function* onMonthlyCheckoutStart(): Generator<any, void, any> {
	yield takeLatest(MONTHLY_CHECKOUT_START as any, getMonthlyCheckoutSaga);
}

export function* onMonthlyCheckoutDetailsStart(): Generator<any, void, any> {
	yield takeLatest(MONTHLY_CHECKOUT_DETAILS_START as any, getMonthlyCheckoutDetailsSaga);
}

export function* monthlyCheckoutSaga(): Generator<any, void, any> {
	yield all([fork(onMonthlyCheckoutStart), fork(onMonthlyCheckoutDetailsStart)]);
}
